var moduleMap = {
	"./Page": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_chakra-ui_avatar_dist_index_esm_js-node_modules_chakra-ui_button_dist_in-50adfd"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("src_Page_index_jsx-src_hooks_useAppTheme_js-src_providers_PreloaderProvider_index_jsx-src_ser-55b34e"), __webpack_require__.e("src_App_js")]).then(() => (() => ((__webpack_require__(54111)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});